// CustomCircleCheck.jsx
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useSelector } from "react-redux";
import { all } from "axios";

/**
 * Props:
 *  - size (number | string) e.g. 20 or "1.25rem"
 *  - bgColor (string) background circle color
 *  - tickColor (string) tick/stroke color
 *  - strokeWidth (number) optional tick stroke width
 *  - className / sx - passthrough
 */
export default function CustomCircleCheck({
  size = 26,
  bgColor = "#28a745",
  tickColor = "#fff",
  strokeWidth = 2,
  className,
  sx,
  ...rest
}) {
  // size can be number (px) or string
  const pxSize = typeof size === "number" ? `${size}px` : size;
  const theme = localStorage.getItem("theme");
  const { allColors } = useSelector((state) => state);

  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fontSize="inherit"
      className={className}
      sx={{
        width: pxSize,
        height: pxSize,
        display: "inline-block",
        mr: 1,
        ...sx,
      }}
      {...rest}
    >
      {/* circle background */}
      <circle cx="12" cy="12" r="10" fill={bgColor} />
      {/* check mark: using path with stroke so tickColor controls it */}
      <path
        d="M7 12.5l2.5 2.5L17 8"
        fill="none"
        stroke={
          theme === "dark" ? allColors.fontColor : allColors.lightFontColor
        }
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
